/* eslint-disable */
// noinspection JSUnusedGlobalSymbols,JSValidateJSDoc

import { register, CloudObject, Tag, Transaction, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DropdownConfig extends CloudObject {

    /**
     * Creates an instance of DropdownConfig.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(DropdownConfig);
    }

    /**
     * @return {string}
     */
    getJson() {
        return this.get(DropdownConfig.jsonProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeJson($) {
        return this.observe($, DropdownConfig.jsonProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {Tag} instance
     * @param {string} value
     */
    static setJson(transaction, instance, value) {
        transaction.update(instance, DropdownConfig.jsonProp, value);
    }

}

// Hardcoded tags
register('0189e445aaf9a8eccc28', DropdownConfig);
DropdownConfig.jsonProp = defineProperty('0189e445d7db1f732274');
